import {
  getCampaignCreateFooterMessage,
  getCampaignCreateFooterUsageLabel,
} from '@/features/campaign/helpers/campaign-create-phase-ux';
import type { CampaignEditorValidationIssue } from '../../../campaign-editor/helpers/campaign-editor-validation';
import type { CampaignEditorSection } from '../../../campaign-editor/campaign-editor-types';

type CampaignCreateFooterViewModelArgs = {
  campaignItemSlotLimit: number;
  isSubmitting: boolean;
  totalTrackedItems: number;
  validationIssue?: CampaignEditorValidationIssue;
  validationIssueCount: number;
};

export type CampaignCreateFooterViewModel = {
  message: string;
  primaryDisabled: boolean;
  primaryLabel: string;
  usageLabel: string;
};

export function getCampaignCreateSectionForValidationIssue({
  currentSection,
  issue,
}: {
  currentSection: CampaignEditorSection;
  issue: CampaignEditorValidationIssue;
}): CampaignEditorSection {
  switch (issue.section) {
    case 'tracking-items':
      return currentSection === 'campaign-info' ? 'creators' : currentSection;
    default:
      return issue.section;
  }
}

export function getCampaignCreateFooterViewModel({
  campaignItemSlotLimit,
  isSubmitting,
  totalTrackedItems,
  validationIssue,
  validationIssueCount,
}: CampaignCreateFooterViewModelArgs): CampaignCreateFooterViewModel {
  return {
    message: getCampaignCreateFooterMessage({
      campaignItemSlotLimit,
      issue: validationIssue,
    }),
    primaryDisabled: validationIssueCount > 0 || isSubmitting,
    primaryLabel: 'Create Campaign',
    usageLabel: getCampaignCreateFooterUsageLabel({
      limit: campaignItemSlotLimit,
      usedCount: totalTrackedItems,
    }),
  };
}
